/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 优惠券状态
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<member.Codebook>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/coupons-status`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
